export default {
  actionRetencao({commit}, retencao){
    commit("setRetencao", retencao)
  }
}
